/* eslint-disable */
import _ from 'lodash';
/** utility function to return updated object from */
export const updateObject = (toBeUpdated, updatedProps) => {
    return {
        ...toBeUpdated,
        ...updatedProps,
    };
};
/**
 * @param name : field name
 * @param value : value of the field
 * @param rules : rules associated with it
 */
export const isValidField = (name, value, rules) => {
    name;
    let isValid = true;
    if (!rules) {
        return true;
    }
    if (rules.required && isValid) {
        if (_.isString(value)) {
            isValid = value.trim() !== '';
        }
        else {
            isValid = value !== undefined && value !== null;
        }
        isValid ? (rules.error = '') : (rules.error = rules.requiredError);
    }
    if (rules.minLength && isValid) {
        isValid = value.length >= rules.minLength;
        isValid ? (rules.error = '') : (rules.error = rules.minLengthError);
    }
    if (rules.maxLength && isValid) {
        isValid = value.length <= rules.maxLength;
        isValid ? (rules.error = '') : (rules.error = rules.maxLengthError);
    }
    if (rules.isEmail && isValid) {
        const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
        isValid = pattern.test(value);
        isValid ? (rules.error = '') : (rules.error = rules.isEmailError);
    }
    if (rules.regex && isValid) {
        if (rules.required === false && value.trim() === '') {
            isValid = true;
        }
        else {
            const pattern = new RegExp(rules.regex);
            isValid = pattern.test(value);
            isValid ? (rules.error = '') : (rules.error = rules.regexError);
        }
    }
    if (rules.range && isValid) {
        /** Sample range validation string "5-10" */
        const pattern = rules.range.split('-');
        const min = parseFloat(pattern[0]);
        const max = parseFloat(pattern[1]);
        const tempValue = parseFloat(value);
        isValid =
            isValid &&
                !isNaN(tempValue) &&
                tempValue >= min &&
                tempValue <= max;
        isValid ? (rules.error = '') : (rules.error = rules.rangeError);
    }
    if (rules.isNumeric && isValid) {
        const pattern = /^[0-9]+$/;
        isValid = pattern.test(value);
        isValid ? (rules.error = '') : (rules.error = rules.isNumericError);
    }
    if (rules.fileTypes && isValid) {
        if (value) {
            if ('name' in value) {
                const { name } = value;
                const curentFileExtension = name.substr(name.lastIndexOf('.') + 1, name.length);
                isValid = rules.fileTypes.allowedExtensions.includes(curentFileExtension);
            }
            else if (value.length > 1) {
                for (let i = 0; i < value.length; i++) {
                    const { name } = value[i];
                    const curentFileExtension = name.substr(name.lastIndexOf('.') + 1, name.length);
                    isValid = rules.fileTypes.allowedExtensions.includes(curentFileExtension);
                    if (!isValid) {
                        break;
                    }
                }
            }
            isValid
                ? (rules.error = '')
                : (rules.error = rules.fileTypes.errorMessage);
        }
    }
    if (rules.maxFileSize && isValid) {
        if (value) {
            if ('size' in value) {
                const { size } = value;
                const currentFileSizeInKbs = size;
                isValid = currentFileSizeInKbs < rules.maxFileSize.maxSize;
                isValid
                    ? (rules.error = '')
                    : (rules.error = rules.maxFileSize.errorMessage);
            }
            else if (value.length > 1) {
                for (let i = 0; i < value.length; i++) {
                    const { size } = value[i];
                    const currentFileSizeInKbs = size;
                    isValid = currentFileSizeInKbs > rules.maxFileSize.maxSize;
                    if (!isValid) {
                        break;
                    }
                }
                isValid
                    ? (rules.error = '')
                    : (rules.error = rules.maxFileSize.errorMessage);
            }
        }
    }
    return isValid;
};
//# sourceMappingURL=index.js.map